enum LocalStorageKeys {
  GuestId = 'guestId',
  Token = 'token',
  RefreshToken = 'refreshToken',
  SelectedLanguage = 'selectedLanguage',
}

export default LocalStorageKeys;
